import { TooltipProps } from '@yandex-lego/components/Tooltip/desktop/bundle';
import React, { ReactNode, useEffect, useState } from 'react';

import { Tooltip } from '../../LegoTooltip/LegoTooltip';

import './palette__tooltip.scss';

interface Props {
    show: boolean;
    delayShow?: number;
    target: React.RefObject<HTMLElement>;
    direction: TooltipProps['direction'];
    children: ReactNode;
}

const PaletteTooltip = ({ children, show, delayShow = 400, target, direction }: Props) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const delayHide = 0;
        const delay = show ? delayShow : delayHide;

        const timeout = setTimeout(() => {
            if (show) {
                setVisible(true);
            } else {
                setVisible(false);
            }
        }, delay);

        return () => clearTimeout(timeout);
    }, [delayShow, show, setVisible]);

    // для полной перерисовки тултипа при изменении его содержимого
    useEffect(() => {
        setVisible(false);

        const timeout = setTimeout(() => {
            if (show) {
                setVisible(true);
            }
        }, 0);

        return () => clearTimeout(timeout);
    }, [children, show]);

    return (
        <Tooltip
            anchor={target}
            className="palette__tooltip"
            direction={direction}
            hasTail
            mainOffset={14}
            size="s"
            view="default"
            visible={visible}
        >
            {children}
        </Tooltip>
    );
};

export default PaletteTooltip;
